import axios from 'axios';

export const server_URL = 'https://stude.app'

export default axios.create({
    baseURL: server_URL + ':3000'
});